import { BadgeIconStateType } from '../../../../../../components/badgeIcon/types/badgeIconStateType';
import { BadgeIconVariantType } from '../../../../../../components/badgeIcon/types/badgeIconVariantType';
import { commonStyles } from '../commonStyles';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [BadgeIconVariantType.REGULAR]: {
            [BadgeIconStateType.DEFAULT]: {
                ...commonStyles(FOUNDATIONS, FONT),
                container: {
                    ...commonStyles(FOUNDATIONS, FONT).container,
                    background_color: FOUNDATIONS.color_comp_resources_badgeicon_default_bg,
                    border_color: FOUNDATIONS.color_comp_resources_badgeicon_border,
                },
                icon: {
                    ...commonStyles(FOUNDATIONS, FONT).icon,
                    color: FOUNDATIONS.color_neutral_icon_50,
                },
            },
            [BadgeIconStateType.DISABLED]: {
                container: {
                    ...commonStyles(FOUNDATIONS, FONT).container,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    border_color: FOUNDATIONS.color_accent_disabled_border_100,
                },
                icon: {
                    ...commonStyles(FOUNDATIONS, FONT).icon,
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
            },
        },
    };
};
//# sourceMappingURL=regular.js.map